import { Link } from "react-router-dom";

export default function Logo({ compact = false }) {
    return (
        <Link to="/" data-testid="logo-link" className="group flex items-center gap-3">
            <svg
                viewBox="0 0 64 64"
                className="h-9 w-9 shrink-0 md:h-10 md:w-10"
                aria-hidden="true"
            >
                <rect width="64" height="64" rx="10" fill="#162238" stroke="#22344E" />
                <path d="M14 16h36" stroke="#F8FAFC" strokeWidth="5" strokeLinecap="square" />
                <path
                    d="M21 16v20a11 11 0 0 0 22 0V16"
                    fill="none"
                    stroke="#FF6B00"
                    strokeWidth="6"
                    strokeLinecap="square"
                />
            </svg>
            {!compact && (
                <span className="flex flex-col leading-none">
                    <span className="font-display text-2xl font-extrabold uppercase tracking-wide text-white md:text-[1.6rem]">
                        Uma
                    </span>
                    <span className="font-mono text-[0.55rem] tracking-[0.42em] text-slate-400">
                        ENGINEERING
                    </span>
                </span>
            )}
        </Link>
    );
}
